
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.5 24a.737.737 0 01-.447-.148.744.744 0 01-.258-.345c-.05-.09-.877-1.449-5.206-1.607l-.036.001A1.55 1.55 0 019 20.419v-7.8a1.56 1.56 0 011.707-1.486c3.304.125 4.964.909 5.793 1.64.832-.731 2.5-1.516 5.835-1.643a1.547 1.547 0 011.1.354A1.549 1.549 0 0124 12.619v7.8a1.546 1.546 0 01-1.546 1.482l-.048-.001c-4.34.159-5.148 1.506-5.201 1.605l-.009.022A.762.762 0 0116.5 24zm.75-2.476c.937-.522 2.512-1.031 5.131-1.124h.062c.037 0 .052-.017.058-.036V12.67a.05.05 0 00-.02-.03.058.058 0 00-.041-.014h-.008c-3.896.149-4.954 1.229-5.181 1.543v7.355zm-6.623-1.123c2.613.093 4.187.601 5.123 1.123V14.17c-.218-.292-1.292-1.394-5.143-1.54l-.039-.002c-.032 0-.042.008-.049.013a.052.052 0 00-.019.028v7.695c.008.023.03.037.059.037l.034-.001.034.001z"}}),_c('path',{attrs:{"d":"M3.483 22.501A3.487 3.487 0 010 19.02V3.484A3.486 3.486 0 013.483.001H9.75a3.754 3.754 0 013.75 3.75V9A.75.75 0 0112 9V3.751a2.252 2.252 0 00-2.25-2.25H3.483A1.985 1.985 0 001.5 3.484v13.017h5.25a.75.75 0 010 1.5H1.5v1.018c0 1.093.89 1.982 1.982 1.982H6.75a.75.75 0 010 1.5H3.483z"}})])
          )
        }
      }
    